export type { RichTextProps, RichTextClassKey } from './RichText.types';
export { default } from './RichText';
